interface MenuCardProps {
  label: string;
  icon: string;
  alt: string;
  onClick: () => void;
  imageClassName?: string;
  cardClassName?: string;
  labelClassName?: string;
}

const MenuCard = ({
  label,
  icon,
  alt,
  onClick,
  imageClassName = 'h-[90px] object-contain',
  cardClassName = 'p-[25px]',
  labelClassName = 'text-center',
}: MenuCardProps) => (
  <li
    className={`w-[200px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105 ${cardClassName}`}
    onClick={onClick}
  >
    <img src={icon} alt={alt} className={imageClassName} />
    <p className={labelClassName}>{label}</p>
  </li>
);

export default MenuCard;
